export default __webpack_public_path__ + "static/media/ico-edit.df1a471d.svg";